import { PublicClientApplication, LogLevel } from '@azure/msal-browser';

// These are injected at build time via environment variables.
// In production set REACT_APP_AZURE_CLIENT_ID and REACT_APP_AZURE_TENANT_ID
// in App Service → Configuration → Application settings.
const CLIENT_ID = process.env.REACT_APP_AZURE_CLIENT_ID || '';
const TENANT_ID = process.env.REACT_APP_AZURE_TENANT_ID || '';

export const msalConfig = {
  auth: {
    clientId: CLIENT_ID,
    authority: `https://login.microsoftonline.com/${TENANT_ID}`,
    redirectUri: window.location.origin + '/relationship-hub',
    postLogoutRedirectUri: window.location.origin + '/relationship-hub',
  },
  cache: {
    cacheLocation: 'sessionStorage',
    storeAuthStateInCookie: false,
  },
  system: {
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) return;
        if (process.env.NODE_ENV === 'development') {
          console.log('[MSAL]', message);
        }
      },
      logLevel: LogLevel.Warning,
    },
  },
};

// Scopes requested when acquiring a token
// openid/profile/email are standard OIDC scopes
// The api:// scope requests an access token for our app's API
export const loginRequest = {
  scopes: ['openid', 'profile', 'email'],
};

export const msalInstance = new PublicClientApplication(msalConfig);
